import React, { useState } from 'react';
import { XIcon, UploadIcon, ChevronDownIcon, MinusCircleIcon, PlusCircleIcon } from 'lucide-react';
interface ServiceDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  service?: any;
}
export const ServiceDetailModal: React.FC<ServiceDetailModalProps> = ({
  isOpen,
  onClose,
  service
}) => {
  const [formData, setFormData] = useState({
    name: service?.name || '',
    shortName: service?.name || '',
    disclaimer: service?.description || '',
    priceRule: 'Fix Price and Quantity',
    realEstreamFee: '20.0',
    feeUnit: 'Percentage',
    cancelFee: '',
    locations: ['GTA'],
    realEstate: true,
    trend: true,
    freeConsultation: true,
    active: service?.active ?? true,
    descriptionPlaceholder: '',
    serviceCallShortInfo: 'Service Call - Starting From',
    serviceCallBasePrice: '158',
    serviceCallAdditionalInfo: '',
    serviceCallAdditionalPrice: '',
    additionalApplianceShortInfo: 'For each additional appliance',
    additionalApplianceBasePrice: '78',
    additionalApplianceAdditionalInfo: '',
    additionalApplianceAdditionalPrice: ''
  });
  const [expandedSections, setExpandedSections] = useState({
    serviceCall: false,
    additionalAppliance: false
  });
  if (!isOpen) return null;
  const handleInputChange = (field: string, value: any) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const toggleSection = (section: string) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-182">
      <div className="bg-white rounded-lg w-full max-w-6xl max-h-[90vh] overflow-hidden flex flex-col" data-id="element-183">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200" data-id="element-184">
          <div className="flex items-center space-x-3" data-id="element-185">
            <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full" data-id="element-186">
              <XIcon size={20} className="text-gray-600" data-id="element-187" />
            </button>
          </div>
          <button className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm font-medium" data-id="element-188">
            Save
          </button>
        </div>
        <div className="flex-1 overflow-y-auto" data-id="element-189">
          <div className="grid grid-cols-2 gap-6 p-6" data-id="element-190">
            <div className="space-y-6" data-id="element-191">
              <h2 className="text-lg font-semibold text-gray-800" data-id="element-192">General</h2>
              <div className="flex justify-center" data-id="element-193">
                <div className="relative" data-id="element-194">
                  <div className="w-24 h-24 rounded-full bg-yellow-400 flex items-center justify-center overflow-hidden" data-id="element-195">
                    {service?.logo && <span className="text-4xl" data-id="element-196">{service.logo}</span>}
                  </div>
                  <button className="absolute bottom-0 right-0 w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700" data-id="element-197">
                    <UploadIcon size={14} className="text-white" data-id="element-198" />
                  </button>
                </div>
              </div>
              <div data-id="element-199">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-200">
                  <span className="text-red-500" data-id="element-201">*</span> Name
                </label>
                <div className="relative" data-id="element-202">
                  <input type="text" value={formData.name} onChange={e => handleInputChange('name', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-203" />
                  <button className="absolute right-2 top-1/2 transform -translate-y-1/2 text-blue-500" data-id="element-204">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" data-id="element-205">
                      <path d="M8 0a8 8 0 100 16A8 8 0 008 0zm1 12H7V7h2v5zm0-6H7V4h2v2z" data-id="element-206" />
                    </svg>
                  </button>
                </div>
              </div>
              <div data-id="element-207">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-208">
                  <span className="text-red-500" data-id="element-209">*</span> Short Name
                </label>
                <input type="text" value={formData.shortName} onChange={e => handleInputChange('shortName', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-210" />
              </div>
              <div data-id="element-211">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-212">
                  <span className="text-red-500" data-id="element-213">*</span> Disclaimer
                </label>
                <textarea value={formData.disclaimer} onChange={e => handleInputChange('disclaimer', e.target.value)} rows={4} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 resize-none" data-id="element-214" />
              </div>
              <div data-id="element-215">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-216">
                  <span className="text-red-500" data-id="element-217">*</span> Price Rule
                </label>
                <select value={formData.priceRule} onChange={e => handleInputChange('priceRule', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-218">
                  <option data-id="element-219">Fix Price and Quantity</option>
                  <option data-id="element-220">Variable Price</option>
                  <option data-id="element-221">Hourly Rate</option>
                </select>
              </div>
              <div data-id="element-222">
                <label className="block text-sm text-gray-600 mb-1" data-id="element-223">
                  Real Estream Fee
                </label>
                <input type="text" value={formData.realEstreamFee} onChange={e => handleInputChange('realEstreamFee', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-224" />
              </div>
              <div data-id="element-225">
                <label className="block text-sm text-gray-600 mb-1" data-id="element-226">
                  Real Estream Fee Unit
                </label>
                <select value={formData.feeUnit} onChange={e => handleInputChange('feeUnit', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-227">
                  <option data-id="element-228">Percentage</option>
                  <option data-id="element-229">Fixed Amount</option>
                </select>
              </div>
              <div data-id="element-230">
                <label className="block text-sm text-gray-600 mb-1" data-id="element-231">
                  Cancel Fee
                </label>
                <input type="text" value={formData.cancelFee} onChange={e => handleInputChange('cancelFee', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-232" />
              </div>
              <div data-id="element-233">
                <label className="block text-sm text-gray-600 mb-2" data-id="element-234">
                  Locations
                </label>
                <div className="flex flex-wrap gap-2" data-id="element-235">
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-blue-500 text-white" data-id="element-236">
                    GTA
                  </span>
                </div>
              </div>
              <div className="space-y-3" data-id="element-237">
                <label className="flex items-center space-x-3" data-id="element-238">
                  <input type="checkbox" checked={formData.realEstate} onChange={e => handleInputChange('realEstate', e.target.checked)} className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500" data-id="element-239" />
                  <span className="text-sm text-gray-700" data-id="element-240">Real Estate</span>
                </label>
                <label className="flex items-center space-x-3" data-id="element-241">
                  <input type="checkbox" checked={formData.trend} onChange={e => handleInputChange('trend', e.target.checked)} className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500" data-id="element-242" />
                  <span className="text-sm text-gray-700" data-id="element-243">Trend</span>
                </label>
                <label className="flex items-center space-x-3" data-id="element-244">
                  <input type="checkbox" checked={formData.freeConsultation} onChange={e => handleInputChange('freeConsultation', e.target.checked)} className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500" data-id="element-245" />
                  <span className="text-sm text-gray-700" data-id="element-246">
                    Free Consultation
                  </span>
                </label>
                <label className="flex items-center space-x-3" data-id="element-247">
                  <input type="checkbox" checked={formData.active} onChange={e => handleInputChange('active', e.target.checked)} className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500" data-id="element-248" />
                  <span className="text-sm text-gray-700" data-id="element-249">Active</span>
                </label>
              </div>
              <div data-id="element-250">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-251">
                  <span className="text-red-500" data-id="element-252">*</span> Description place
                  holder
                </label>
                <textarea value={formData.descriptionPlaceholder} onChange={e => handleInputChange('descriptionPlaceholder', e.target.value)} placeholder="Please Add Images of Appliance, Serial Number When Possible." rows={4} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 resize-none" data-id="element-253" />
              </div>
            </div>
            <div className="space-y-6" data-id="element-254">
              <div className="flex items-center justify-between" data-id="element-255">
                <h2 className="text-lg font-semibold text-gray-800" data-id="element-256">Price</h2>
                <button className="text-cyan-500 hover:text-cyan-600" data-id="element-257">
                  <PlusCircleIcon size={24} data-id="element-258" />
                </button>
              </div>
              <div className="space-y-4" data-id="element-259">
                <div className="border border-gray-200 rounded-md" data-id="element-260">
                  <button onClick={() => toggleSection('serviceCall')} className="w-full flex items-center justify-between p-3 hover:bg-gray-50" data-id="element-261">
                    <div className="flex items-center space-x-2" data-id="element-262">
                      <ChevronDownIcon size={16} className={`text-gray-500 transition-transform ${!expandedSections.serviceCall ? '-rotate-90' : ''}`} data-id="element-263" />
                      <span className="text-sm font-medium text-gray-700" data-id="element-264">
                        Service Call - Starting From
                      </span>
                    </div>
                    <MinusCircleIcon size={20} className="text-red-500" data-id="element-265" />
                  </button>
                  {expandedSections.serviceCall && <div className="p-4 space-y-4 border-t border-gray-200" data-id="element-266">
                      <div data-id="element-267">
                        <label className="block text-xs text-gray-900 mb-1" data-id="element-268">
                          * Short Info
                        </label>
                        <input type="text" value={formData.serviceCallShortInfo} onChange={e => handleInputChange('serviceCallShortInfo', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 text-sm" data-id="element-269" />
                      </div>
                      <div data-id="element-270">
                        <label className="block text-xs text-gray-900 mb-1" data-id="element-271">
                          * Base Price
                        </label>
                        <input type="text" value={formData.serviceCallBasePrice} onChange={e => handleInputChange('serviceCallBasePrice', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 text-sm" data-id="element-272" />
                      </div>
                      <div data-id="element-273">
                        <label className="block text-xs text-gray-600 mb-1" data-id="element-274">
                          Additional Info
                        </label>
                        <input type="text" value={formData.serviceCallAdditionalInfo} onChange={e => handleInputChange('serviceCallAdditionalInfo', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 text-sm" data-id="element-275" />
                      </div>
                      <div data-id="element-276">
                        <label className="block text-xs text-gray-600 mb-1" data-id="element-277">
                          Additional price
                        </label>
                        <input type="text" value={formData.serviceCallAdditionalPrice} onChange={e => handleInputChange('serviceCallAdditionalPrice', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 text-sm" data-id="element-278" />
                      </div>
                    </div>}
                </div>
                <div className="border border-gray-200 rounded-md" data-id="element-279">
                  <button onClick={() => toggleSection('additionalAppliance')} className="w-full flex items-center justify-between p-3 hover:bg-gray-50" data-id="element-280">
                    <div className="flex items-center space-x-2" data-id="element-281">
                      <ChevronDownIcon size={16} className={`text-gray-500 transition-transform ${!expandedSections.additionalAppliance ? '-rotate-90' : ''}`} data-id="element-282" />
                      <span className="text-sm font-medium text-gray-700" data-id="element-283">
                        For each additional appliance
                      </span>
                    </div>
                    <MinusCircleIcon size={20} className="text-red-500" data-id="element-284" />
                  </button>
                  {expandedSections.additionalAppliance && <div className="p-4 space-y-4 border-t border-gray-200" data-id="element-285">
                      <div data-id="element-286">
                        <label className="block text-xs text-gray-900 mb-1" data-id="element-287">
                          * Short Info
                        </label>
                        <input type="text" value={formData.additionalApplianceShortInfo} onChange={e => handleInputChange('additionalApplianceShortInfo', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 text-sm" data-id="element-288" />
                      </div>
                      <div data-id="element-289">
                        <label className="block text-xs text-gray-900 mb-1" data-id="element-290">
                          * Base Price
                        </label>
                        <input type="text" value={formData.additionalApplianceBasePrice} onChange={e => handleInputChange('additionalApplianceBasePrice', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 text-sm" data-id="element-291" />
                      </div>
                      <div data-id="element-292">
                        <label className="block text-xs text-gray-600 mb-1" data-id="element-293">
                          Additional Info
                        </label>
                        <input type="text" value={formData.additionalApplianceAdditionalInfo} onChange={e => handleInputChange('additionalApplianceAdditionalInfo', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 text-sm" data-id="element-294" />
                      </div>
                      <div data-id="element-295">
                        <label className="block text-xs text-gray-600 mb-1" data-id="element-296">
                          Additional price
                        </label>
                        <input type="text" value={formData.additionalApplianceAdditionalPrice} onChange={e => handleInputChange('additionalApplianceAdditionalPrice', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 text-sm" data-id="element-297" />
                      </div>
                    </div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};